import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { Modules } from '../entity/module.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { ErrorResponse, ModuleModel, ModuleResponse } from '@schemax-whatsapp/shared-models';
import { ModuleIdRequest } from './models/module-id.request';
import { BiMessageService } from '../bi-message/bi-message.service';

@Injectable()
export class ModuleService {

    constructor(
        @InjectRepository(Modules) private moduleRepo: Repository<Modules>,
        @Inject(forwardRef(() => BiMessageService)) private biMsgService: BiMessageService
    ) {
         
    }

    /**
     * 
     * @param moduleReq 
     * @returns 
     */
    async createModule(moduleReq: ModuleModel): Promise<ModuleResponse> {
        const moduleRec = await this.getModuleByModuleName(moduleReq.moduleName);
        if(moduleRec) {
            throw new ErrorResponse(0, 'Module exist within the company');
        }
        const moduleEnt = this.convertModuleModelToEntity(moduleReq.moduleName, moduleReq.moduleDesc, moduleReq.username);
        const savedModule = await this.moduleRepo.save(moduleEnt);
        const moduleModel = this.convertModuleEntityToModel(savedModule);
        return new ModuleResponse(true, 0, 'Module saved successfully', [moduleModel]);
    }

   

    /**
     * 
     * @param moduleReq 
     * @returns 
     */
    async editModule(moduleReq: ModuleModel): Promise<ModuleResponse> {
        const moduleRec = await this.getModuleByModuleId(moduleReq.moduleId);
        if(!moduleRec) {
            throw new ErrorResponse(0, 'Module does not exist');
        }
        await this.moduleRepo.update({moduleId: moduleReq.moduleId}, {moduleDesc: moduleReq.moduleDesc} );
        const moduleEnt = await this.getModuleByModuleId(moduleReq.moduleId);
        const moduleModel = this.convertModuleEntityToModel(moduleEnt);
        return new ModuleResponse(true, 0, 'Module edited successfully', [moduleModel]);
    }

    /**
     * 
     * @param moduleIdReq 
     * @returns 
     */
    async deleteModule(moduleIdReq: ModuleIdRequest): Promise<ModuleResponse> {
        const moduleRec = await this.getModuleByModuleId(moduleIdReq.moduleId);
        if(!moduleRec) {
            throw new ErrorResponse(0, 'Module does not exist');
        }
        // check if the role has any bi messages defined
        await this.biMsgService.checkIfBiMessageExistForModuleIdAndThrowErrorIfExist(moduleIdReq.moduleId);
        await this.moduleRepo.delete({ moduleId: moduleIdReq.moduleId });
        return new ModuleResponse(true, 0, 'Module deleted successfully');
    }

    /**
     * 
     * @param companyIdReq 
     */
    async getAllModules(): Promise<ModuleResponse> {
        const moduleModels: ModuleModel[] = [];
        const modules = await this.moduleRepo.find({ where: { isActive: true } });
        for(const module of modules) {
            const moduleModel = new ModuleModel(module.moduleId, module.moduleName, module.moduleDesc, module.createdUser);
            moduleModels.push(moduleModel);
        }
        return new ModuleResponse(true, 0, 'Modules retrieved successfully', moduleModels);
    }

    /**
     * 
     * @param moduleId 
     * @returns 
     */
    async getModuleByModuleId(moduleId: number): Promise<Modules> {
        return await this.moduleRepo.findOne({ where: {moduleId: moduleId, isActive: true} });
    }

    /**
     * 
     * @param moduleName 
     * @returns 
     */
    async getModuleByModuleName(moduleName: string): Promise<Modules> {
        return await this.moduleRepo.findOne({ where: {moduleName: moduleName, isActive: true}});
    }

    /**
     * 
     * @param moduleName 
     * @param moduleDesc 
     * @param username 
     * @returns 
     */
    convertModuleModelToEntity(moduleName: string, moduleDesc: string, username: string): Modules {
        const moduleEnt = new Modules();
        moduleEnt.moduleName = moduleName;
        moduleEnt.moduleDesc = moduleDesc;
        moduleEnt.createdUser = username;
        return moduleEnt;
    }

    /**
     * 
     * @param moduleEnt 
     * @returns 
     */
    convertModuleEntityToModel(moduleEnt: Modules): ModuleModel {
        const moduleModel = new ModuleModel(moduleEnt.moduleId, moduleEnt.moduleName, moduleEnt.moduleDesc, moduleEnt.moduleDesc);
        return moduleModel;
    }
}
